module.exports = "https://static.web-explore.prod.moonpig.net/_next/static/images/logo-square-win8-cb9b8a0bd86d4ec7a87efa49c56484d1.png";